export default __webpack_public_path__ + "3eb30c4d580d383121a00c3ce690fbb8.png";